import { accountConstants } from '../_constants';

let token = JSON.parse(localStorage.getItem('token'));
const initialState = token ? { loggedIn: true, token } : {};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case accountConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        token: action.token
      };
    case accountConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        token: action.token
      };
    case accountConstants.LOGIN_FAILURE:
      return {};
    case accountConstants.LOGOUT:
      return {};
    default:
      return state
  }
}